{
	"title": "Inhoud",
	"answerTime": "[NOG INVULLEN: 1 werkdag]",
	"updated": "Bijgewerkt op {{date}}",
	"nav": {
		"label": "Hulp",
		"about": "Over ons",
		"shippingReturns": "Verzenden en retourneren",
		"terms": "Algemene voorwaarden",
		"withdrawal": "Herroeping",
		"faq": "Veelgestelde vragen",
		"contact": "Contact",
		"privacy": "Privacy",
		"cookies": "Cookies"
	},
	"shipping": {
		"title": "Wat het kost",
		"country": "Land",
		"rate": "Verzendkosten",
		"freeFrom": "Gratis vanaf",
		"noFreeFrom": "Niet"
	},
	"faq": {
		"meta": "Per onderwerp. Staat je vraag er niet bij?",
		"toContact": "Neem contact op",
		"topics": {
			"label": "Onderwerpen",
			"fit": "Pasvorm",
			"ordering": "Bestellen",
			"payment": "Betalen",
			"shipping": "Verzenden",
			"business": "Zakelijk"
		},
		"more": {
			"title": "Nog een vraag?",
			"text": "We antwoorden binnen {{time}}.",
			"link": "Naar contact"
		}
	},
	"contact": {
		"subjects": {
			"fit": "Vraag over de pasvorm",
			"order": "Mijn bestelling",
			"return": "Retour",
			"business": "Zakelijk",
			"other": "Iets anders"
		},
		"orderNumber": "Bestelnummer",
		"orderNumberHint": "(als je dat hebt)",
		"messageHint": "Over de pasvorm? Zet de lengte en breedte van de voet erbij.",
		"submit": "Verstuur bericht",
		"sent": {
			"title": "Verzonden",
			"text": "Bedankt. Je krijgt een kopie op {{email}}, en we antwoorden binnen {{time}}.",
			"again": "Nog een bericht sturen"
		},
		"details": {
			"email": "E-mail",
			"phone": "Telefoon",
			"company": "Bedrijfsgegevens"
		}
	},
	"notFound": {
		"code": "Foutcode 404",
		"title": "Deze pagina bestaat niet (meer).",
		"text": "Misschien is de link oud, of is het product van naam veranderd. Kies je wisser of zoek wat je nodig hebt.",
		"searchPlaceholder": "Zoek op product of maat, bijv. 46×27",
		"toHome": "Naar de homepage",
		"toContact": "Contact"
	}
}
